// 报警服务
import CallPolice from '../view/CallPolice/CallPolice'
import CallPoliceNav from '../view/CallPolice/CallPoliceNav'

export default [
    {
        path: '/call_police',
        name: 'call-police',
        components: {
            default: CallPoliceNav,
            a: CallPolice
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/CallPolice.js